import { render, staticRenderFns } from "./UserPopup.vue?vue&type=template&id=8094af6a&scoped=true"
import script from "./UserPopup.vue?vue&type=script&lang=ts"
export * from "./UserPopup.vue?vue&type=script&lang=ts"
import style0 from "./UserPopup.vue?vue&type=style&index=0&id=8094af6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8094af6a",
  null
  
)

export default component.exports